export const MAPPING_NOT_AVAILABLE_ERROR = 'mapping-not-available-error';

export const AUTH0_FLOW_TYPE_KEY = 'auth0AuthFlowType';
export const AUTH0_FLOW_TYPE_REGISTRATION = 'registration';
export const AUTH0_FLOW_TYPE_SIGNIN = 'signin';
export const AUTH0_REGISTRATION_SUCCESS_PENDING =
  'auth0_registration_success_pending';
